// extracted by css-extract-rspack-plugin
export default {"buildLocator":"RmZd1PpKo5tJVRAq"};